import Card from "@/components/common/Card";
import IconPicker from "@/components/common/IconPicker";
import FlightDateRange from "@/components/common/FlightDateRange";

export default function Step1Basics({ form, onFieldChange }) {
  return (
    <Card className="builder-form flex flex-col gap-5">
      <div className="form-group-modal">
        <label htmlFor="campaign-name">Campaign name</label>
        <div className="flex items-center gap-3">
          <IconPicker
            iconOnly
            value={form.icon ?? ""}
            onChange={(next) => onFieldChange("icon", next || null)}
          />
          <input
            id="campaign-name"
            className="flex-1"
            value={form.name}
            onChange={(event) => onFieldChange("name", event.target.value)}
            placeholder="e.g. Spring Awareness Push"
            required
          />
        </div>
      </div>

      <div className="form-group-modal">
        <label htmlFor="campaign-description">Description</label>
        <textarea
          id="campaign-description"
          value={form.description}
          onChange={(event) => onFieldChange("description", event.target.value)}
          placeholder="Short description, goals, or context for the campaign…"
          rows={3}
        />
      </div>

      <div className="form-group-modal max-w-md">
        <label>Flight dates</label>
        <FlightDateRange
          startDate={form.startDate ?? ""}
          endDate={form.endDate ?? ""}
          onChange={(start, end) => {
            onFieldChange("startDate", start);
            onFieldChange("endDate", end);
          }}
        />
      </div>
    </Card>
  );
}
